// extracted by mini-css-extract-plugin
export default {"head":"T_JbnwA80_HrflWFdVo6","cell":"O1iQLnzDC6RehMMKBuxD"};